// extracted by mini-css-extract-plugin
module.exports = {"container":"TemperatureInfo_container_11Hlx","title":"TemperatureInfo_title_1SFc5","data":"TemperatureInfo_data_fchpG"};